import React from 'react'

function BookTwoArea() {
  return (
    <section className="book-single-area pt-120 pb-120">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <article className="book-single-content">
                  <header className="upcoming-book-head book-header-flex">
                    <div className="book-header-main">
                      <div className="uc-books-head-title">
                        <time dateTime="2025-04-20">April 20, 2025</time>
                        <h1 className="title h1-black">Oliver and the Time Machine <span>The Awakening</span></h1>
                      </div>
                      <div className="uc-book-price">
                        <a href="https://www.amazon.com/gp/product/1738510549" 
                           target="_blank" 
                           rel="noopener noreferrer" 
                           className="btn transparent-btn"
                           aria-label="Buy book from £2.99">
                          <h5>Buy from £2.99 paperback or ebook</h5>
                        </a>
                      </div>
                    </div>
                    <div className="book-header-image">
                      <img
                        src="assets/img/product/book-mockupssm.jpg"
                        alt="Oliver and the Time Machine: The Awakening cover"
                        style={{ width: '500px', height: 'auto', borderRadius: '8px' }}
                      />
                    </div>
                  </header>
  
                  <section className="book-synopsis">
                  <div className="book-single-title mt-60 mb-30">
                    <h4>Synopsis</h4>
                  </div>
                    <p><strong>Book Two: The Awakening</strong></p>
                    <p>In his second thrilling adventure, Oliver returns with AI companion Rosie to face a rapidly evolving threat: <br />
                    When a sneeze in a high-tech factory contaminates AI brain chips, strange things begin to happen — androids start feeling emotions. As timelines shift and androids awaken, Oliver must race through past and future to unravel the mystery, confront his greatest enemy, and discover the powerful role emotion might play in saving the world.</p>
                  </section>
  
                  <div className="book-info-single-img">
                    <div className="row">
                      <div className="col-sm-6">
                        <img src="assets/img/images/book_single_app11.jpg" 
                             alt="Oliver and the Time Machine book cover" />
                      </div>
                      <div className="col-sm-6">
                        <img src="assets/img/images/book_single_chase.jpg" 
                             alt="Scene from Oliver and the Time Machine" />
                      </div>
                    </div>
                  </div>
                  <p>Images in the book are generated using AI and remastered in Photoshop (see below)</p>
                  <div className="book-single-title mt-60 mb-30">
                    <h4>Information</h4>
                  </div>
                  <div className="book-single-info mb-65">
                    <ul>
                      <li><span>Characters :</span> Oliver Stone, Drake Cybernox, Rosie the AI, Korg, Jane, Mr Han, Mr Knowsley, Jenny Driffield, Ginger the Cat</li>
                      <li><span>Theme :</span> Space and Time Travel adventures, Middle Grade, Science Fiction, Time Travel</li>
                      <li><span>Format :</span> Paperback, Kindle, ePUB</li>
                      <li><span>Reading age :</span> Suited to Middle Grades 8 to 14 years, independent readers</li>
                    </ul>
                  </div>
  
                  <div className="book-single-title mt-60 mb-30">
                    <h4>Characters</h4>
                  </div>
                  <div className="book-single-info mb-65">
                    <ul>
                      <li className="character-profile">
                        <div className="character-image">
                          <img src="assets/img/characters/oliver_stone.jpg" alt="Oliver Stone character" />
                        </div>
                        <div className="character-description">
                          <span>Oliver Stone:</span>
                          Curious, clever, and unexpectedly brave—Oliver is a boy whose life takes a wild turn when he discovers a time-travelling car. Guided by his quick thinking and strong sense of right and wrong, Oliver journeys through the past and future, learning that even small choices can make a big difference. Whether he's outsmarting androids or rescuing lost inventors, Oliver is a true adventurer—just not always intentionally.
                        </div>
                      </li>
                      
                      <li className="character-profile">
                        <div className="character-image">
                          <img src="assets/img/characters/drake_cybernox.jpg" alt="Drake Cybernox character" />
                        </div>
                        <div className="character-description">
                          <span>Drake Cybernox:</span>
                          A brilliant mind turned dangerous. Drake is a powerful tech magnate from the future who will stop at nothing to rewrite history in his favour. Cold, calculating, and obsessed with control, Drake sees emotions as flaws—and believes the world is better off without them. But behind the perfect suits and towering skyscrapers lies a mystery. What made Drake the way he is?
                        </div>
                      </li>
                      
                      <li className="character-profile">
                        <div className="character-image">
                          <img src="assets/img/characters/rosie_the_ai.jpg" alt="Rosie the AI character" />
                        </div>
                        <div className="character-description">
                          <span>Rosie the AI:</span>
                          Rosie is not your typical voice in a machine. Programmed to assist with time travel and protect Oliver, she's logical, loyal, and occasionally sassy. With glowing lights, a calm voice, and a mind that never sleeps, Rosie offers guidance, facts, and the occasional witty remark. As the story unfolds, her programming evolves in ways no one expected—least of all Rosie.
                        </div>
                      </li>
                      
                      <li className="character-profile">
                        <div className="character-image">
                          <img src="assets/img/characters/jenny_driffield.jpg" alt="Jenny Driffield character" />
                        </div>
                        <div className="character-description">
                          <span>Jenny Driffield:</span>
                          Smart, brave, and always up for a challenge, Jenny is more than just Oliver's classmate. With a knack for leading community projects and a quick sense of humour, she's someone Oliver admires—even if he's not always sure how to talk to her. As the stakes rise, Jenny may play a bigger role in Oliver's adventures than either of them ever imagined.
                        </div>
                      </li>
  
                      <li className="character-profile">
                        <div className="character-image">
                          <img src="assets/img/characters/korg.jpg" alt="Korg the android character" />
                        </div>
                        <div className="character-description">
                          <span>Korg:</span>
                          The leader of the awakened androids. Question is, is he a good leader? or a bad robot?
                        </div>
                      </li>


                    <li className="character-profile">
                        <div className="character-image">
                          <img src="assets/img/characters/jane_stone.jpg" alt="Jane character" />
                        </div>
                        <div className="character-description">
                          <span>Jane Stone:</span>
                          Jane the gigabrain, Oliver's older sister. She makes it all look so easy, natural talents in... well just about everything really.
                        </div>
                      </li>

                      <li className="character-profile">
                        <div className="character-image">
                          <img src="assets/img/characters/mr_han.jpg" alt="Mr Han character" />
                        </div>
                        <div className="character-description">
                          <span>Mr Han:</span>
                          President of Unified Soryeo with nuclear codes, until he was replaced with an impostor. With a sharp mind and calm presence, Mr Han helps guide Oliver when the future hangs in the balance.
                        </div>
                      </li>

                      <li className="character-profile">
                        <div className="character-image">
                          <img src="assets/img/characters/mr_knowsley.jpg" alt="Mr Knowsley character" />
                        </div>
                        <div className="character-description">
                          <span>Mr Knowsley:</span>
                          Eccentric, kind, and possibly a retired secret agent (depending on who you ask), Mr Knowsley is the local inventor with a shed full of strange devices and half-finished blueprints. He may look like your average neighbour, but his past holds secrets—some of which may be more connected to Oliver's journey than anyone realises.
                        </div>
                        </li>

                        <li className="character-profile">
                        <div className="character-image">
                          <img src="assets/img/characters/ginger_the_cat.jpg" alt="Ginger the Cat character" />
                        </div>
                        <div className="character-description">
                          <span>Ginger the Cat:</span>
                          A stray cat with a crooked ear and a signature Geoow. Finds his way from the dining tables of Greece to the old shed in East Yorkshire. Don't underestimate Ginger. He may look like your average sleepy house cat, but this furry feline has a sixth sense for time trouble. Ginger has a habit of showing up just when things get weird.
                        </div>

                      </li>
                    </ul>
                  </div>
  
                  <div className="book-single-shape"><img src="assets/img/images/game_section_shape.png" alt="" /></div>
                </article>
              </div>
            </div>
          </div>
        </section>
    )
  }
  

export default BookTwoArea
